import CareersData from "@/components/careers/careers-data";
import { Component } from "@builder.io/sdk";

export const careersDataConfig: Component = {
  name: "Careers Data",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "careers-data",
      helperText: "The ID of the careers data section",
      advanced: true,
    },
    {
      name: "healthcareProviders",
      type: "number",
      defaultValue: 400,
      helperText: "Number of healthcare providers",
    },
    {
      name: "openPositions",
      type: "number",
      defaultValue: 20,
      helperText: "Number of open positions",
    },
    {
      name: "availableRoles",
      type: "list",
      defaultValue: [
        "Home Care Aide",
        "Licensed Vocational Nurse",
        "Registered Nurse",
        "Office Employee",
        "Certified Nursing Assistant",
      ],
      helperText: "List of available roles to be displayed with animation",
      subFields: [
        {
          name: "role",
          type: "string",
          defaultValue: "",
          helperText: "Enter a job role title",
        },
      ],
    },
    {
      name: "animationDuration",
      type: "number",
      defaultValue: 3000,
      helperText:
        "Duration between role transitions in milliseconds (3000 = 3 seconds)",
      advanced: true,
    },
    {
      name: "className",
      type: "string",
      advanced: true,
      helperText: "Additional CSS classes to apply to the component",
    },
  ],
};

export default CareersData;
